import React, { Component } from "react";
import Swiper from "react-id-swiper";
import { find } from "lodash";
import StoneItem from "../Stone/StoneItem";
import { MAX_WIDTH_SP } from "../../const";

export default class ModalFortuneList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fortuneList: [],
      idActive: 0
    };
  }

  componentDidMount() {
    this.setState({ fortuneList: this.props.fortuneList });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fortuneList !== this.props.fortuneList) {
      this.setState({ fortuneList: this.props.fortuneList });
    }
  }

  handleGetHeight() {
    let heightWin = window.innerHeight;

    return heightWin - 343;
  }

  handleChangeTab(index) {
    this.setState({ idActive: index });
  }

  render() {
    let { fortuneList, idActive } = this.state;
    let params = {
      loadMinimal: true,
      loadMinimalSize: 0,
      slidesPerView: "auto",
      loop: false,
      key: fortuneList.length
    };
    let { productList, handleUpdateState, getWidthBrowser } = this.props;
    let stoneList = [];
    let productIds = [];
    let filterList = [];

    if (fortuneList.length > 0) {
      productIds = fortuneList[idActive].product_ids;

      productIds.map(data => {
        let item = find(productList, function(prod) {
          return prod.id === data.id;
        });
        if (item !== undefined) {
          filterList.push(item);
        }
      });
    }

    stoneList = filterList.map((item, index) => {
      return (
        <StoneItem
          key={index}
          stone={item}
          handleUpdateState={handleUpdateState}
          productList={productList}
        />
      );
    });

    return (
      <div
        className={`tab_content ${
          getWidthBrowser() < MAX_WIDTH_SP ? "modal_sp" : ""
        }`}
      >
        <div
          className={`sub_tab ${
            getWidthBrowser() < MAX_WIDTH_SP ? "" : "center_mode"
          }`}
        >
          <Swiper {...params}>
            {fortuneList.map((item, index) => {
              return (
                <div
                  className="sub_tab_item"
                  onClick={() => this.handleChangeTab(index)}
                  key={index}
                >
                  <button className={`${index === idActive ? "active" : ""}`}>
                    {item.name}
                  </button>
                </div>
              );
            })}
          </Swiper>
        </div>
        <div className="material_list_wrap scroll_bar_style">
          <ul className="material_list">{stoneList}</ul>
        </div>
      </div>
    );
  }
}
